import MainLayout from "@/layouts/MainLayout";
import { type NextPage } from "next";
import { AboutHeadingSection } from "../AboutHeadingSection";

export const AboutPage: NextPage = () => {
  return (
    <MainLayout footerBackgroundColor="tertiary.200">
      <AboutHeadingSection />
    </MainLayout>
  );
};
